import { get, httpDelete, patch, post, put } from '../../utils/http';

export const fetchSequences = ({ accountId, projects, kind, withSubmissions, types }) =>
  get(`/accounts/${accountId}/sequences`, { projects, kind, withSubmissions, types });

export const addSequence = ({ accountId, ...body }) => post(`/accounts/${accountId}/sequences`, body);

export const putSequence = ({ accountId, payloads }) => put(`/accounts/${accountId}/sequences`, { ...payloads });

export const fetchSequence = ({ accountId, sequenceId }) => get(`/accounts/${accountId}/sequences/${sequenceId}`);

export const updateSequence = ({ accountId, sequenceId, ...body }) =>
  patch(`/accounts/${accountId}/sequences/${sequenceId}`, body);

export const fetchSequenceResult = ({ accountId, sequenceId, instanceId }) =>
  get(`/accounts/${accountId}/sequences/${sequenceId}/instances/${instanceId}/export`);

export const publishSequenceToNotAnswered = ({ accountId, sequenceId }) =>
  post(`/accounts/${accountId}/sequences/${sequenceId}/publishToNotAnswered`);

export const updateSequencesPriority = ({ accountId, sequences }) =>
  post(`/accounts/${accountId}/sequences/priority`, { sequences });

export const deleteSequence = ({ accountId, sequenceId }) =>
  httpDelete(`/accounts/${accountId}/sequences/${sequenceId}`);

// Params: sequenceInstances -{{sequenceId: number, instanceId: number}[]}
export const fetchMultipleSequenceResults = ({ accountId, sequenceInstances }) =>
  post(`/accounts/${accountId}/sequences/bulk-export`, { sequenceInstances });
